import axios from '../axios'
// 车运预约表列表
export const getMeterBookingCarPage = (data) => {
  return axios({
    url: '/api/sys/meter/getMeterBookingCarPage',
    method: 'post',
    data
  })
}
// 司机预约
export const appointment = (data) => {
  return axios({
    url: '/api/sys/pur/order/appointment',
    method: 'post',
    data
  })
}
// 司机预约修改
export const updPurArrivalEntry = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/updPurArrivalEntry',
    method: 'post',
    data
  })
}
// 保存车运预约
export const saveMeterBookingCar = (data) => {
  return axios({
    url: '/api/sys/meter/saveMeterBookingCar',
    method: 'post',
    data
  })
}
// 修改车运预约
export const updateMeterBookingCar = (data) => {
  return axios({
    url: '/api/sys/meter/updateMeterBookingCar',
    method: 'post',
    data
  })
}
// 修改车运车牌
export const updateCarNo = (data) => {
  return axios({
    url: '/api/sys/meter/updateCarNo',
    method: 'post',
    data
  })
}
// 修改车运预约（修改图片）
export const uploadImages = (data) => {
  return axios({
    url: '/api/sys/meter/uploadImages',
    method: 'post',
    data
  })
}
// 修改车运预约(强制修改nfc卡号)
export const updateMeterBookingNfcNo = (data) => {
  return axios({
    url: '/api/sys/meter/updateMeterBookingNfcNo',
    method: 'post',
    data
  })
}
// 预约审批
export const appointmentApproval = (data) => {
  return axios({
    url: '/api/sys/meter/appointmentApproval',
    method: 'post',
    data
  })
}
// 预约反审批
export const cancelAppointmentApproval = (data) => {
  return axios({
    url: '/api/sys/meter/cancelAppointmentApproval',
    method: 'post',
    data
  })
}
// 客商取消预约
export const cancelAppointment = (data) => {
  return axios({
    url: '/api/sys/meter/cancelAppointment',
    method: 'post',
    data
  })
}
// 客商预约作废
export const removeAppointment = (data) => {
  return axios({
    url: '/api/sys/meter/removeAppointment',
    method: 'post',
    data
  })
}
// 作废已经入场未过一次磅车辆预约
export const closeMeterBookingCar = (data) => {
  return axios({
    url: '/api/sys/meter/closeMeterBookingCar',
    method: 'post',
    data
  })
}
// 预约车辆入厂
export const enteringFactory = (data) => {
  return axios({
    url: '/api/sys/meter/enteringFactory',
    method: 'post',
    data
  })
}
// 预约车辆入厂打印
export const print = (data) => {
  return axios({
    url: '/api/sys/meter/print',
    method: 'post',
    data
  })
}
// 预约车辆手动入场
export const manualEntry = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/manualEntry',
    method: 'post',
    data
  })
}
// 车辆手动离场
export const manualDeparture = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/manualDeparture',
    method: 'post',
    data
  })
}
// 确认装货
export const loadingConfirmation = (data) => {
  return axios({
    url: '/api/sys/meter/meterWayCar/loadingConfirmation',
    method: 'post',
    data
  })
}
// 确认装货撤回
export const cancelLoadingConfirmation = (data) => {
  return axios({
    url: '/api/sys/meter/meterWayCar/cancelLoadingConfirmation',
    method: 'post',
    data
  })
}
// 空车提交
export const submitForApproval = (data) => {
  return axios({
    url: '/api/sys/meter/meterWayCar/submitForApproval',
    method: 'post',
    data
  })
}
// 空车审批
export const heavyEmptyVehiclesApproval = (data) => {
  return axios({
    url: '/api/sys/meter/meterWayCar/heavyEmptyVehiclesApproval',
    method: 'post',
    data
  })
}
// 磅差审批
export const weightDifferenceApproval = (data) => {
  return axios({
    url: '/api/sys/meter/meterWayCar/weightDifferenceApproval',
    method: 'post',
    data
  })
}
// 车运空车审批明细
export const getMeterWayCarApprovePage = (data) => {
  return axios({
    url: '/api/sys/meter/meterWayCar/getMeterWayCarApprovePage',
    method: 'post',
    data
  })
}
// 入场后修改集装箱号
export const updMeterBookContainer = (data) => {
  return axios({
    url: '/api/sys/meter/updMeterBookContainer',
    method: 'post',
    data
  })
}
//导出入场登记
export const exportMeterBookingCarList = (data) => {
  return axios({
    url: '/api/sys/meter/exportMeterBookingCarList',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/moudules/Reservation.js